import useSearchParamsWithUpdate from "helpers/hooks/useSearchParamsWithUpdate";
import GroupedEntries from "./GroupedEntries";
import EntryTimeline from "./EntryTimeline";
import { NewEntryTable } from "components/NewEntryTable";
import { useFlags } from "launchdarkly-react-client-sdk";
import { parseSafeInt } from "Backend";
import { FormFieldContext } from "contexts/FormFieldContext";
import { useContext, useMemo } from "react";

export default function Entries({ viewMode }: { viewMode: "grouped" | "timeline" }) {
  const { searchParams } = useSearchParamsWithUpdate();
  const { newResponseTable } = useFlags();
  const ffContext = useContext(FormFieldContext);
  const fieldId = parseSafeInt(searchParams.get("fieldId"));
  const referenceContext = useMemo(() => {
    if (ffContext.formField.id !== fieldId) return;
    const valueGroupId = parseSafeInt(searchParams.get("valueGroupId"));
    const referenceId = parseSafeInt(searchParams.get("referenceId"));
    const page = parseSafeInt(searchParams.get("page"));

    const canConstructReferenceContext =
      fieldId !== undefined && valueGroupId !== undefined && referenceId !== undefined;
    return canConstructReferenceContext ? { valueGroupId, referenceId, page } : undefined;
  }, [fieldId, searchParams]);
  const TableComponent = newResponseTable ? NewEntryTable : GroupedEntries;
  return viewMode === "grouped" ? <TableComponent defaultEntryContext={referenceContext} /> : <EntryTimeline />;
}
